/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useSelector } from 'react-redux'
import { getBanners } from '@client/selectors/appSelectors'
import { getBannersByPlatform } from '@client/utils/getBannersByPlatform'

import styles from './SupportPanel.module.css'

export const SupportPanel = () => {
  const bannersData = useSelector(getBanners)

  const banners = getBannersByPlatform(bannersData?.button)
  const banner = banners?.[0]

  const style = {
    '--background-color': banner?.bg
  } as React.CSSProperties

  return (
    <div className={styles.root} style={style}>
      {banner && (
        <a className={styles.link} href={banner.url} target="_blank">
          <picture className={styles.picture}>
            <source srcSet={banner.desktop} media="(min-width: 64em)" />
            <source srcSet={banner.mobile} media="(max-width: 63.9375em)" />
            <img src={banner.mobile} alt={banner.alt} />
          </picture>

          <span className={styles.text}>{banner.alt}</span>
        </a>
      )}
    </div>
  )
}
